



export const CHANGE_EXAMPLE = 'CHANGE_EXAMPLE'
export const CHANGE_DASHBOARDVIEW = 'CHANGE_DASHBOARDVIEW'
export const CHANGE_STOCK = 'CHANGE_STOCK'
export const CHANGE_RISK = 'CHANGE_RISK'
export const CHANGE_STOCK_VIEW = 'CHANGE_STOCK_VIEW'
export const CHANGE_STOCK_CHART = 'CHANGE_STOCK_CHART'
export const CHANGE_ACCOUNT = 'CHANGE_ACCOUNT'
export const CHANGE_SUPPORT = 'CHANGE_SUPPORT'
export const CHANGE_BASKET = 'CHANGE_BASKET'
export const CHANGE_SIGNAL = 'CHANGE_SIGNAL'
export const CHANGE_ANALYSIS = 'CHANGE_ANALYSIS'
export const CHANGE_PUBLIC = 'CHANGE_PUBLIC'
export const CHANGE_INQUIRY = 'CHANGE_INQUIRY'
export const CHANGE_AICHAT = 'CHANGE_AICHAT'
export const CHANGE_AICHAT_LIST = 'CHANGE_AICHAT_LIST'
export const CHANGE_TRANSFORMATION = 'CHANGE_TRANSFORMATION'
export const CHANGE_AICHAT_ADD_END = 'CHANGE_AICHAT_ADD_END'
export const CHANGE_AICHAT_REPLACE_END = 'CHANGE_AICHAT_REPLACE_END'
export const CHANGE_AICHAT_PAGE_LIST = 'CHANGE_AICHAT_PAGE_LIST'

//AUTH
export const CHANGE_AUTH = 'CHANGE_AUTH'
export const CHANGE_TIMER = 'CHANGE_TIMER'
export const CHANGE_PROFILE = 'CHANGE_PROFILE'
export const CHANGE_AUTH_SET_PERMISSION = 'CHANGE_AUTH_SET_PERMISSION'
export const HAS_PERMISSION = 'HAS_PERMISSION'
export const AUTH_SET_INFO = 'AUTH_SET_INFO'



